import React from 'react';
import { FileText } from 'lucide-react';
import './ButtonPdf.css';

const ButtonPdf = ({ onClick, disabled }) => {
    return (
        <button
            className="boton-pdf"
            onClick={onClick}
            disabled={disabled}
            title="Exportar a PDF"
        >
            <FileText />
            <span>Exportar</span>
        </button>
    );
};

export default ButtonPdf;